(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-soft-life-scent-mate]";

  var OILS = {
    glow: {
      name: "Soft Life Glow",
      collection: "Luxe Body Oil",
      notes: "vanilla · marshmallow · caramel · musk"
    },
    champ: {
      name: "Champagne Dreams",
      collection: "Luxe Body Oil",
      notes: "champagne · berries · violet · cashmere musk"
    },
    date: {
      name: "Date Night",
      collection: "Luxe Body Oil",
      notes: "rose · jasmine · amber · vanilla bean"
    },
    rich: {
      name: "Rich Energy",
      collection: "Luxe Body Oil",
      notes: "amber · saffron · cedar · jasmine"
    },
    sge: {
      name: "Soft Girl Era",
      collection: "Luxe Body Oil",
      notes: "peony · jasmine · suede · musk"
    }
  };

  var FAMILIES = {
    gourmand: {
      label: "Sweet gourmand",
      match: "glow",
      second: "rich",
      why: "Sweet, edible notes layer beautifully over Soft Life Glow’s vanilla, marshmallow, caramel, and musk—warmer, softer, and longer-lasting."
    },
    fruity: {
      label: "Fruity sweet",
      match: "champ",
      second: "glow",
      why: "Berry and fruit notes echo Champagne Dreams’ sparkling heart for a bright, effervescent layer."
    },
    floral: {
      label: "Floral",
      match: "sge",
      second: "date",
      why: "Soft Girl Era’s peony, jasmine, suede, and musk blend seamlessly with floral fragrances while gently extending the bouquet."
    },
    rosy: {
      label: "Rose floral",
      match: "date",
      second: "sge",
      why: "Date Night’s rose, jasmine, amber, and vanilla bean deepen a rosy bouquet into something warmer and more alluring."
    },
    amber: {
      label: "Warm amber-spice",
      match: "rich",
      second: "date",
      why: "Rich Energy’s amber, saffron, cedar, and jasmine ground warm, spicy scents and add magnetic staying power."
    },
    woody: {
      label: "Woody",
      match: "rich",
      second: "glow",
      why: "Rich Energy meets woody fragrances on common ground with cedar and amber, adding warmth and depth."
    },
    musk: {
      label: "Clean musk",
      match: "sge",
      second: "glow",
      why: "Soft Girl Era’s soft musk extends a clean skin scent without overpowering its intimate character."
    },
    fresh: {
      label: "Fresh & citrus",
      match: "sge",
      second: "champ",
      why: "Soft Girl Era gives fresh, airy scents a soft floral-musk base so they settle warmly onto the skin."
    }
  };

  var KEYWORDS = [
    ["gourmand", ["vanilla","caramel","marshmallow","sugar","sweet","praline","chocolate","cocoa","coffee","honey","almond","pistachio","cake","cream","milk","tonka","cupcake","cookie","candy","coconut","rum","tobacco"]],
    ["fruity", ["berry","berries","cherry","peach","apple","pear","raspberry","strawberry","fruit","fruity","plum","blackcurrant","lychee","litchi","mango","pineapple","guava","melon","apricot","fig","pomegranate"]],
    ["rosy", ["rose","damask","rosy","rosewater"]],
    ["amber", ["amber","saffron","oud","incense","resin","spice","spicy","cinnamon","clove","ambery","benzoin","balsam","myrrh","opoponax"]],
    ["woody", ["sandalwood","cedar","wood","woody","vetiver","patchouli","oakmoss","santal","oak","leather","suede","mahogany","teakwood"]],
    ["musk", ["musk","skin scent","white musk","ambrette","ambrox","ambroxan","cetalox","cashmeran"]],
    ["floral", ["jasmine","peony","gardenia","tuberose","lily","floral","flower","orange blossom","neroli","ylang","iris","violet","freesia","magnolia","blossom","lavender","orchid","osmanthus","carnation"]],
    ["fresh", ["citrus","bergamot","lemon","aquatic","fresh","marine","green","mint","cucumber","sea","ocean","grapefruit","yuzu","lime","aqua","sage","tea","water lily","lotus"]]
  ];

  var MINIMAL_DATABASE = [
    {name:"Burberry Her",notes:"dark berries · jasmine · amber · musk · vanilla",family:"fruity"},
    {name:"Kayali Vanilla 28",notes:"brown sugar · vanilla · jasmine · amber",family:"gourmand"},
    {name:"YSL Black Opium",notes:"coffee · vanilla · white flowers · cedar",family:"gourmand"},
    {name:"Maison Francis Kurkdjian Baccarat Rouge 540",notes:"saffron · jasmine · amberwood · cedar",family:"amber"},
    {name:"Chanel Chance Eau Tendre",notes:"grapefruit · quince · jasmine · white musk",family:"fruity"},
    {name:"Dior Miss Dior",notes:"rose · peony · iris · musk",family:"rosy"},
    {name:"Gucci Bloom",notes:"tuberose · jasmine · rangoon creeper",family:"floral"},
    {name:"Le Labo Santal 33",notes:"sandalwood · cardamom · leather · cedar",family:"woody"},
    {name:"Glossier You",notes:"pink pepper · iris · ambrette musk · ambrox",family:"musk"},
    {name:"Dolce & Gabbana Light Blue",notes:"green apple · bluebell · cedar · musk",family:"fresh"}
  ];

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function normalizeText(value) {
    var text = String(value || "").toLowerCase();

    if (text.normalize) {
      text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return text
      .replace(/&/g, " and ")
      .replace(/\beau de parfum\b/g, " ")
      .replace(/\beau de toilette\b/g, " ")
      .replace(/\bedp\b/g, " ")
      .replace(/\bedt\b/g, " ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .replace(/^\s+|\s+$/g, "");
  }

  function classifyText(value) {
    var text = normalizeText(value);
    var bestFamily = "";
    var bestCount = 0;
    var familyIndex;
    var wordIndex;
    var count;

    for (familyIndex = 0; familyIndex < KEYWORDS.length; familyIndex += 1) {
      count = 0;

      for (wordIndex = 0; wordIndex < KEYWORDS[familyIndex][1].length; wordIndex += 1) {
        if (text.indexOf(normalizeText(KEYWORDS[familyIndex][1][wordIndex])) !== -1) {
          count += 1;
        }
      }

      if (count > bestCount) {
        bestCount = count;
        bestFamily = KEYWORDS[familyIndex][0];
      }
    }

    return bestFamily || null;
  }

  function levenshtein(a, b) {
    var matrix = [];
    var i;
    var j;
    var cost;

    if (!a.length) {
      return b.length;
    }
    if (!b.length) {
      return a.length;
    }

    for (i = 0; i <= b.length; i += 1) {
      matrix[i] = [i];
    }

    for (j = 0; j <= a.length; j += 1) {
      matrix[0][j] = j;
    }

    for (i = 1; i <= b.length; i += 1) {
      for (j = 1; j <= a.length; j += 1) {
        cost = b.charAt(i - 1) === a.charAt(j - 1) ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + cost,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }

    return matrix[b.length][a.length];
  }

  function scoreRecord(query, record) {
    var q = normalizeText(query);
    var name = record._normalized || normalizeText(record.name);
    var qTokens;
    var nameTokens;
    var tokenMatches = 0;
    var i;
    var distance;
    var ratio;
    var score = 0;

    if (!q || !name) {
      return 0;
    }

    if (name === q) {
      return 1;
    }

    if (name.indexOf(q) === 0) {
      score = Math.max(score, 0.96 - Math.min(0.12, (name.length - q.length) / 100));
    }

    if (name.indexOf(q) !== -1) {
      score = Math.max(score, 0.9 - Math.min(0.16, (name.length - q.length) / 100));
    }

    if (q.indexOf(name) !== -1) {
      score = Math.max(score, 0.86);
    }

    qTokens = q.split(" ");
    nameTokens = name.split(" ");

    for (i = 0; i < qTokens.length; i += 1) {
      if (qTokens[i].length > 1 && nameTokens.indexOf(qTokens[i]) !== -1) {
        tokenMatches += 1;
      }
    }

    if (qTokens.length) {
      score = Math.max(score, (tokenMatches / qTokens.length) * 0.84);
    }

    if (q.length <= 60 && name.length <= 90) {
      distance = levenshtein(q, name);
      ratio = 1 - distance / Math.max(q.length, name.length);
      score = Math.max(score, ratio * 0.9);
    }

    return score;
  }

  function normalizeRecord(raw) {
    var record = raw || {};
    var name = record.name || record.n || record.title || record.fragrance_name || "";
    var notes = record.notes || record.note || record.description || "";
    var family = record.family || record.f || record.olfactive_family || record.fragrance_family || "";

    if (Object.prototype.toString.call(notes) === "[object Array]") {
      notes = notes.join(" · ");
    } else if (notes && typeof notes === "object") {
      notes = flattenNotes(notes);
    }

    if (!name && record.brand && record.product_name) {
      name = String(record.brand) + " " + String(record.product_name);
    }

    family = mapFamily(family, notes);

    return {
      name: String(name || ""),
      notes: String(notes || ""),
      family: family,
      _normalized: normalizeText(name)
    };
  }

  function flattenNotes(notesObject) {
    var parts = [];
    var key;
    var value;

    for (key in notesObject) {
      if (Object.prototype.hasOwnProperty.call(notesObject, key)) {
        value = notesObject[key];

        if (Object.prototype.toString.call(value) === "[object Array]") {
          parts = parts.concat(value);
        } else if (typeof value === "string") {
          parts.push(value);
        }
      }
    }

    return parts.join(" · ");
  }

  function mapFamily(value, notes) {
    var text = normalizeText(value + " " + (notes || ""));

    if (text.indexOf("gourmand") !== -1 || text.indexOf("sweet") !== -1 || text.indexOf("vanilla") !== -1) {
      return "gourmand";
    }
    if (text.indexOf("fruit") !== -1) {
      return "fruity";
    }
    if (text.indexOf("rose") !== -1) {
      return "rosy";
    }
    if (text.indexOf("amber") !== -1 || text.indexOf("oriental") !== -1 || text.indexOf("spicy") !== -1) {
      return "amber";
    }
    if (text.indexOf("wood") !== -1 || text.indexOf("chypre") !== -1 || text.indexOf("leather") !== -1) {
      return "woody";
    }
    if (text.indexOf("musk") !== -1 || text.indexOf("skin") !== -1) {
      return "musk";
    }
    if (text.indexOf("floral") !== -1 || text.indexOf("flower") !== -1) {
      return "floral";
    }
    if (text.indexOf("fresh") !== -1 || text.indexOf("citrus") !== -1 || text.indexOf("aquatic") !== -1 || text.indexOf("green") !== -1) {
      return "fresh";
    }

    return classifyText(notes || value) || "floral";
  }

  function parseRemoteRecords(payload) {
    var list = payload;
    var output = [];
    var i;
    var record;

    if (!payload) {
      return output;
    }

    if (payload.results) {
      list = payload.results;
    } else if (payload.fragrances) {
      list = payload.fragrances;
    } else if (payload.data) {
      list = payload.data;
    }

    if (Object.prototype.toString.call(list) !== "[object Array]") {
      list = [list];
    }

    for (i = 0; i < list.length; i += 1) {
      record = normalizeRecord(list[i]);
      if (record.name) {
        output.push(record);
      }
    }

    return output;
  }

  function buildEndpoint(endpoint, query) {
    if (!endpoint) {
      return "";
    }

    if (endpoint.indexOf("{query}") !== -1) {
      return endpoint.replace("{query}", encodeURIComponent(query));
    }

    return endpoint + (endpoint.indexOf("?") === -1 ? "?" : "&") + "q=" + encodeURIComponent(query);
  }

  function findClosest(element, selector) {
    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  function safeFocus(element) {
    if (!element) {
      return;
    }

    element.setAttribute("tabindex", "-1");

    try {
      element.focus({preventScroll:true});
    } catch (error) {
      element.focus();
    }
  }

  function smoothScroll(element) {
    if (!element || !element.scrollIntoView) {
      return;
    }

    try {
      element.scrollIntoView({behavior:"smooth",block:"nearest"});
    } catch (error) {
      element.scrollIntoView();
    }
  }

  function initScentMate(root) {
    var databaseUrl;
    var apiEndpoint;
    var maxSuggestions;
    var search;
    var suggestions;
    var stage;
    var resultTemplate;
    var pickerTemplate;
    var status;
    var database = [];
    var visibleResults = [];
    var activeIndex = -1;
    var remoteTimer = null;
    var lastRemoteQuery = "";
    var productMap;

    if (!root || root.getAttribute("data-sl-sm-initialized") === "true") {
      return;
    }

    search = root.querySelector("[data-search]");
    suggestions = root.querySelector("[data-suggestions]");
    stage = root.querySelector("[data-stage]");
    resultTemplate = root.querySelector("[data-result-template]");
    pickerTemplate = root.querySelector("[data-picker-template]");
    status = root.querySelector("[data-database-status]");

    if (!search || !suggestions || !stage || !resultTemplate || !pickerTemplate) {
      return;
    }

    root.setAttribute("data-sl-sm-initialized", "true");

    databaseUrl = root.getAttribute("data-database-url") || "";
    apiEndpoint = root.getAttribute("data-api-endpoint") || "";
    maxSuggestions = parseInt(root.getAttribute("data-max-suggestions"), 10) || 8;

    productMap = {
      glow: {
        url: root.getAttribute("data-glow-url") || "/collections/all",
        image: root.getAttribute("data-glow-image") || ""
      },
      champ: {
        url: root.getAttribute("data-champ-url") || "/collections/all",
        image: root.getAttribute("data-champ-image") || ""
      },
      date: {
        url: root.getAttribute("data-date-url") || "/collections/all",
        image: root.getAttribute("data-date-image") || ""
      },
      rich: {
        url: root.getAttribute("data-rich-url") || "/collections/all",
        image: root.getAttribute("data-rich-image") || ""
      },
      sge: {
        url: root.getAttribute("data-sge-url") || "/collections/all",
        image: root.getAttribute("data-sge-image") || ""
      }
    };

    function setStatus(message, isError) {
      if (!status) {
        return;
      }

      status.textContent = message || "";
      if (isError) {
        status.classList.add("is-error");
      } else {
        status.classList.remove("is-error");
      }
    }

    function prepareDatabase(records) {
      var prepared = [];
      var i;
      var record;

      for (i = 0; i < records.length; i += 1) {
        record = normalizeRecord(records[i]);
        if (record.name) {
          prepared.push(record);
        }
      }

      return prepared;
    }

    function loadDatabase() {
      if (!databaseUrl || !window.fetch) {
        database = prepareDatabase(MINIMAL_DATABASE);
        setStatus(database.length + " popular fragrances ready. Unknown scents can still be matched by notes.", false);
        return;
      }

      window.fetch(databaseUrl, {credentials:"same-origin"})
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Database request failed.");
          }
          return response.json();
        })
        .then(function (payload) {
          var source = payload.fragrances || payload.data || payload;
          database = prepareDatabase(source);
          setStatus(database.length + " fragrances ready—plus note-based matching for anything else.", false);
        })
        .catch(function () {
          database = prepareDatabase(MINIMAL_DATABASE);
          setStatus("The full library could not load, but popular scents and note-based matching are available.", true);
        });
    }

    function searchLocal(query) {
      var scored = [];
      var i;
      var score;

      for (i = 0; i < database.length; i += 1) {
        score = scoreRecord(query, database[i]);
        if (score >= 0.38) {
          scored.push({
            record: database[i],
            score: score,
            source: "local"
          });
        }
      }

      scored.sort(function (a, b) {
        if (b.score === a.score) {
          return a.record.name.localeCompare(b.record.name);
        }
        return b.score - a.score;
      });

      return scored.slice(0, maxSuggestions);
    }

    function mergeResults(localResults, remoteRecords, query) {
      var merged = localResults.slice(0);
      var seen = {};
      var i;
      var normalizedName;
      var score;

      for (i = 0; i < merged.length; i += 1) {
        seen[normalizeText(merged[i].record.name)] = true;
      }

      for (i = 0; i < remoteRecords.length; i += 1) {
        normalizedName = normalizeText(remoteRecords[i].name);

        if (!seen[normalizedName]) {
          score = scoreRecord(query, remoteRecords[i]);
          merged.push({
            record: remoteRecords[i],
            score: Math.max(score, 0.55),
            source: "remote"
          });
          seen[normalizedName] = true;
        }
      }

      merged.sort(function (a, b) {
        return b.score - a.score;
      });

      return merged.slice(0, maxSuggestions);
    }

    function renderSuggestions(results) {
      var html = [];
      var i;
      var item;
      var sourceLabel;

      visibleResults = results || [];
      activeIndex = -1;

      if (!visibleResults.length) {
        suggestions.hidden = true;
        search.setAttribute("aria-expanded", "false");
        return;
      }

      for (i = 0; i < visibleResults.length; i += 1) {
        item = visibleResults[i].record;
        sourceLabel = visibleResults[i].source === "remote" ? " · expanded search" : "";

        html.push(
          '<li role="option" data-result-index="' + i + '">' +
            escapeHtml(item.name) +
            '<span>' + escapeHtml(item.notes || FAMILIES[item.family].label) + escapeHtml(sourceLabel) + '</span>' +
          '</li>'
        );
      }

      suggestions.innerHTML = html.join("");
      suggestions.hidden = false;
      search.setAttribute("aria-expanded", "true");
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function updateActiveSuggestion() {
      var items = suggestions.querySelectorAll("li");
      var i;

      for (i = 0; i < items.length; i += 1) {
        if (i === activeIndex) {
          items[i].classList.add("is-active");
          items[i].setAttribute("aria-selected", "true");
        } else {
          items[i].classList.remove("is-active");
          items[i].setAttribute("aria-selected", "false");
        }
      }
    }

    function queryRemote(query, localResults, callback) {
      var url;

      if (!apiEndpoint || !window.fetch || normalizeText(query) === normalizeText(lastRemoteQuery)) {
        callback(localResults);
        return;
      }

      lastRemoteQuery = query;
      url = buildEndpoint(apiEndpoint, query);

      if (!url) {
        callback(localResults);
        return;
      }

      search.classList.add("is-loading");

      window.fetch(url, {headers:{"Accept":"application/json"}})
        .then(function (response) {
          if (!response.ok) {
            throw new Error("External lookup failed.");
          }
          return response.json();
        })
        .then(function (payload) {
          var remoteRecords = parseRemoteRecords(payload);
          callback(mergeResults(localResults, remoteRecords, query));
        })
        .catch(function () {
          callback(localResults);
        })
        .then(function () {
          search.classList.remove("is-loading");
        });
    }

    function runSearch(query, includeRemote) {
      var localResults = searchLocal(query);

      renderSuggestions(localResults);

      if (includeRemote && apiEndpoint && query.length >= 3) {
        if (remoteTimer) {
          window.clearTimeout(remoteTimer);
        }

        remoteTimer = window.setTimeout(function () {
          queryRemote(query, localResults, function (results) {
            if (normalizeText(search.value) === normalizeText(query)) {
              renderSuggestions(results);
            }
          });
        }, 450);
      }
    }

    function chooseRecord(record) {
      if (!record) {
        return;
      }

      search.value = record.name;
      suggestions.hidden = true;
      search.setAttribute("aria-expanded", "false");
      showMatch(record.name, record.notes, record.family);
    }

    function submitFreeSearch(value) {
      var query = String(value || "").replace(/^\s+|\s+$/g, "");
      var results;
      var best;
      var family;

      suggestions.hidden = true;
      search.setAttribute("aria-expanded", "false");

      if (!query) {
        return;
      }

      results = searchLocal(query);
      best = results.length ? results[0] : null;

      if (best && best.score >= 0.69) {
        chooseRecord(best.record);
        return;
      }

      if (apiEndpoint) {
        queryRemote(query, results, function (combined) {
          var remoteBest = combined.length ? combined[0] : null;

          if (remoteBest && remoteBest.score >= 0.69) {
            chooseRecord(remoteBest.record);
            return;
          }

          family = classifyText(query);

          if (family) {
            showMatch(query, "", family);
          } else {
            showPicker(query);
          }
        });
        return;
      }

      family = classifyText(query);

      if (family) {
        showMatch(query, "", family);
      } else {
        showPicker(query);
      }
    }

    function showMatch(name, notes, familyKey) {
      var family = FAMILIES[familyKey] || FAMILIES.floral;
      var matchOil = OILS[family.match];
      var secondOil = OILS[family.second];
      var fragment = resultTemplate.content.cloneNode(true);
      var image = fragment.querySelector("[data-product-image]");
      var placeholder = fragment.querySelector("[data-product-placeholder]");
      var product = productMap[family.match] || productMap.glow;
      var mounted;

      fragment.querySelector("[data-perfume-name]").textContent = name;
      fragment.querySelector("[data-perfume-notes]").textContent = notes || "Matched using its fragrance family and the notes you described.";
      fragment.querySelector("[data-family]").textContent = family.label;
      fragment.querySelector("[data-match-name]").textContent = matchOil.name;
      fragment.querySelector("[data-match-collection]").textContent = matchOil.collection;
      fragment.querySelector("[data-match-notes]").textContent = matchOil.notes;
      fragment.querySelector("[data-match-why]").textContent = family.why;
      fragment.querySelector("[data-second-name]").textContent = secondOil.name;
      fragment.querySelector("[data-second-notes]").textContent = secondOil.notes;
      fragment.querySelector("[data-shop-link]").setAttribute("href", product.url);
      fragment.querySelector("[data-shop-label]").textContent = "Shop " + matchOil.name;

      if (product.image && image) {
        image.setAttribute("src", product.image);
        image.setAttribute("alt", matchOil.name);
        image.hidden = false;
        if (placeholder) {
          placeholder.hidden = true;
        }
      } else {
        if (image) {
          image.hidden = true;
        }
        if (placeholder) {
          placeholder.hidden = false;
        }
      }

      while (stage.firstChild) {
        stage.removeChild(stage.firstChild);
      }
      stage.appendChild(fragment);

      mounted = stage.querySelector("[data-result]");
      if (mounted) {
        window.setTimeout(function () {
          mounted.classList.add("is-visible");
        }, 20);
      }

      safeFocus(stage.querySelector("[data-match-name]"));
      smoothScroll(stage);
    }

    function showPicker(name) {
      var fragment = pickerTemplate.content.cloneNode(true);
      var pickerName = fragment.querySelector("[data-picker-name]");

      if (pickerName) {
        pickerName.textContent = name;
      }

      while (stage.firstChild) {
        stage.removeChild(stage.firstChild);
      }
      stage.appendChild(fragment);
      smoothScroll(stage);
    }

    search.addEventListener("input", function () {
      var value = search.value.replace(/^\s+|\s+$/g, "");

      if (!value) {
        renderSuggestions([]);
        return;
      }

      runSearch(value, true);
    });

    search.addEventListener("keydown", function (event) {
      var items = suggestions.querySelectorAll("li");

      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        updateActiveSuggestion();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        updateActiveSuggestion();
      } else if (event.key === "Escape") {
        suggestions.hidden = true;
        search.setAttribute("aria-expanded", "false");
      } else if (event.key === "Enter") {
        event.preventDefault();

        if (activeIndex >= 0 && visibleResults[activeIndex]) {
          chooseRecord(visibleResults[activeIndex].record);
        } else {
          submitFreeSearch(search.value);
        }
      }
    });

    root.addEventListener("click", function (event) {
      var suggestionItem = findClosest(event.target, "[data-result-index]");
      var example = findClosest(event.target, "[data-example]");
      var familyChoice = findClosest(event.target, "[data-family-choice]");
      var notesButton = findClosest(event.target, "[data-match-notes]");
      var notesInput;
      var message;
      var family;
      var index;

      if (suggestionItem && root.contains(suggestionItem)) {
        index = parseInt(suggestionItem.getAttribute("data-result-index"), 10);
        if (visibleResults[index]) {
          chooseRecord(visibleResults[index].record);
        }
        return;
      }

      if (example && root.contains(example)) {
        search.value = example.getAttribute("data-example") || "";
        submitFreeSearch(search.value);
        return;
      }

      if (familyChoice && root.contains(familyChoice)) {
        showMatch(
          search.value || "your fragrance",
          "",
          familyChoice.getAttribute("data-family-choice")
        );
        return;
      }

      if (notesButton && root.contains(notesButton)) {
        notesInput = stage.querySelector("[data-notes-input]");
        message = stage.querySelector("[data-picker-message]");
        family = classifyText(notesInput ? notesInput.value : "");

        if (!family) {
          if (message) {
            message.textContent = "Add one or two recognizable notes, such as vanilla, rose, berries, musk, amber, woods, or citrus.";
          }
          return;
        }

        showMatch(
          search.value || "your fragrance",
          notesInput ? notesInput.value : "",
          family
        );
        return;
      }

      if (!findClosest(event.target, ".sl-sm-search-panel")) {
        suggestions.hidden = true;
        search.setAttribute("aria-expanded", "false");
      }
    });

    stage.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && findClosest(event.target, "[data-notes-input]")) {
        event.preventDefault();
        var button = stage.querySelector("[data-match-notes]");
        if (button) {
          button.click();
        }
      }
    });

    loadDatabase();
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll(ROOT_SELECTOR);
    var i;

    for (i = 0; i < roots.length; i += 1) {
      initScentMate(roots[i]);
    }
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
}());
